import { RouteRecordRaw } from "vue-router";
import App from '../../App.vue';

export const CommonRoutes: RouteRecordRaw = {
    path: '/user',
    redirect: "/user/profile",
    component: App,
    meta: {
        title: "Creative Contract Portal",
        metaTags: [
            {
                name: "description",
                content: "Portal",
            },
        ],
    },
    children: [
        {
            path: "profile",
            name: "profile",
            component: () => import("../../modules/common/pages/ProfilePage.vue"),
        },
        {
            path: "comic-preview",
            name: "comic-preview",
            component: () => import("../../modules/common/pages/comic-preview/comic-preview.vue"),
        },
    ],
};